import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { CustomizedFormErrorMessage } from 'components/common';
import { FormProps } from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/RunQsraForm';
import classes from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/RunQsraForm.module.scss';
import { TargetActivitySelect } from 'components/widgets/RiskRegister/components/RunQsra/components/RunQsraForm/components/TargetActivity/components/TargetActivitySelect/TargetActivitySelect';

export const TargetActivity = () => {
    const {
        setValue,
        getValues,
        control,
        formState: { errors },
    } = useFormContext<FormProps>();
    return (
        <>
            <div className={classes.inputTitle}>Target activity</div>
            <div className={classes.inputWrapper}>
                <Controller
                    render={() => (
                        <TargetActivitySelect
                            name={'taskVersionHashCode'}
                            methods={{
                                control,
                                setValue,
                                getValues,
                            }}
                        />
                    )}
                    name={`taskVersionHashCode`}
                    control={control}
                    rules={{
                        required: 'Target activity is Required',
                    }}
                />
            </div>
            {errors.taskVersionHashCode && <CustomizedFormErrorMessage text={errors.taskVersionHashCode.message} />}
        </>
    );
};
